import { render, staticRenderFns } from "./BrandAsset.vue?vue&type=template&id=1f043ed5&scoped=true&"
import script from "./BrandAsset.vue?vue&type=script&lang=js&"
export * from "./BrandAsset.vue?vue&type=script&lang=js&"
import style0 from "./BrandAsset.vue?vue&type=style&index=0&id=1f043ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f043ed5",
  null
  
)

export default component.exports